<template>
  <CommonHeader class="main_head_block">
    <template v-slot:header>
      <span class="module_heading" style="width:fit-content;"> Amazon Products Scraper </span>
      <div class="add_icon_container" @click="navigateToAdd()">
        <i class="fa fa-plus icon_add"  style="margin-left: 13px;"></i>
      </div>
      
      <!-- <i class="fas fa-file-upload icon_one" @click="importExcel" style="margin-left: 6px;"> </i> -->
      <i class="fas fa-upload icon_one" @click = "importExcel"></i>
      <i class="fas fa-download icon_two"  @click = "exportExcel"></i>


      <div class="sel_fil_wrap one">
        <multiselect
          v-model="selectedVendorList"
          :options="vendorsList"
          :show-no-results="true"
          ref="multiselect"
          label="name"
          :track-by="id"
          open-direction="bottom"
          :taggable="false"
          placeholder="All Vendors"
          class="form-control multi-dropdown select_filter"
          selectLabel=""
          selectedLabel=""
          @select="selectVendor($event)"
          @remove="resetFilter()"
          style="width:160px"
        />
      </div>

      <div class="sel_fil_wrap two">
        <multiselect
          v-model="selectedBrandProfle"
          :options="brandProfileList"
          :show-no-results="true"
          :searchable="true"
          ref="multiselect"
          label="name"
          :track-by="id"
          open-direction="bottom"
          :taggable="false"
          placeholder="All Brands"
          class="form-control multi-dropdown select_filter"
          selectLabel=""
          selectedLabel=""
          @select="
            setBrand($event);
            getFilterProducts();
          "
          @remove="resetBrandData()"
          style="width:160px"
        />
      </div>
      <div class="head_search">
        <object
          data="assets/img/search.svg"
          style="height: 18px; width: 18px; margin-left: 5px"
        ></object>
      </div>
      <div class="ghost" @click="getFilterProducts()"></div>
      <div class="head_search_inp">
        <input
          type="search"
          class="form-control search"
          id="search"
          @keyup.enter="getFilterProducts()"
          v-model="searchFilterString"
          placeholder="Title/Asin/Vendor/Brand"
          style="border: none; outline: none; padding: 7px 0px 5px 10px;box-shadow:none"
        />
      </div>

      <!-- <div class="form-group col-md-2">
							<select class="form-control sorting" id="orderBy" v-model="selectedSortOrder" @change="getFilterProducts">
							<option value="">---Sort by ASIN---</option>
							<option value="asc">Ascending</option>
							<option value="desc">Descending</option>
						</select>
					</div>                      -->
      <!-- <div class="form-group col-md-1">
						<a href="javascript:showAdd()" class="add-new"></a>
						<span class="divider"></span>
					</div> -->
      <ExportFilePopUp @closePopUpExport = "closePopUpExport" :isTimeOut = "isTimeOut" :downloadLink = "downloadLink"/>
      <AddDataInBulkModal @closePopUp="closePopUp" />
    </template>
  </CommonHeader>
</template>

<script>
import AddDataInBulkModal from "./AddDataInBulkModal.vue";
import Multiselect from "vue-multiselect";
import CommonHeader from "@/components/CommonHeader.vue";
import  ExportFilePopUp from "@/components/asin-scraper/ExportFilePopUp.vue";
export default {
  name: "AsinScraperListHeader",
  data() {
    return {
      selectedVendorList: [],
      selectedBrandProfle: [],
      isTimeOut: false,
      downloadLink: ''
    };
  },
  components: {
    AddDataInBulkModal,
    Multiselect,
    CommonHeader,
    ExportFilePopUp
  },
  mounted() {
    this.$store.dispatch("getAllBrandProfile");
  },
  computed: {
    selectedSortOrder: {
      set(val) {
        this.$store.state.selectedSortOrder = val;
      },
      get() {
        return this.$store.state.selectedSortOrder;
      },
    },
    searchFilterString: {
      set(val) {
        if (!val) {
          this.$store.state.searchFilterString = val;
          this.$emit("getList");
        } else {
          this.$store.state.searchFilterString = val;
        }
      },
      get() {
        return this.$store.state.searchFilterString;
      },
    },
    vendorsList() {
      let data = this.$store.state.vendorList.filter((e) => e.name);
      if (data && data.length && data[0].id != "all")
        data.unshift({ id: "all", name: "All Vendors" });
      return data;
    },
    brandProfileList: {
      set(val) {
        this.$store.state.brandProfileList = val;
      },
      get() {
        let data = this.$store.state.brandProfileList.filter((e) => e.name);
        if (data && data.length && data[0].id != "all")
          data.unshift({ id: "all", name: "All Brands" });
        return data;
      },
    },
  },
  methods: {
    getFilterProducts() {
      this.$store.state.product.actionSelectionControl = false;
      this.$store.state.product.selectedProducts = [];
      this.$store.state.currentPageNumber = 1;
      this.$emit("getList");
      //this.$store.dispatch('product/getAllProducts')
    },
    navigateToAdd() {
      this.$router.push({
        path: "/asinScraperAddForm",
      });
    },
    importExcel() {
      window.$("#importScrapperData").modal({
        show: true,
      });
    },
    closePopUp() {
      window.$("#importScrapperData").hide();
      this.$emit("getList");
    },
    selectVendor(val) {
      let payload = {
        vendorId: val.id,
      };
      this.$store.state.currentPageNumber = 1;
      if (val.id == "all") {
        let vm = this;
        this.$store.state.selectedVendorFilter = "";
        this.$store.dispatch("getAllBrandProfile").then((res) => {
          let data = res;
          vm.brandProfileList = JSON.parse(JSON.stringify(data));
        });
        this.resetFilter();
      } else {
        this.selectedBrandProfle = [];
        this.$store.state.selectedBrandProduct = "";
        this.$store.state.selectedVendorFilter = val.master_id
          ? val.master_id
          : "null";
        this.$store.dispatch("getAllBrandProfile", payload);
      }
      this.$store.state.product.actionSelectionControl = false;
      this.$store.state.product.selectedProducts = [];
      this.$emit("getList");
    },
    resetFilter() {
      this.$store.state.product.actionSelectionControl = false;
      this.$store.state.product.selectedProducts = [];
      this.$store.state.currentPageNumber = 1;
      this.selectedVendorList = [];
      this.$store.state.selectedVendorFilter = "";
      this.$store.state.selectedBrandProduct = "";
      this.selectedBrandProfle = [];
      this.$emit("getList");
      this.$store.dispatch("getAllBrandProfile");
    },
    setBrand(data) {
      this.$store.state.currentPageNumber = 1;
      this.$store.state.product.actionSelectionControl = false;
      this.$store.state.product.selectedProducts = [];
      if (data.id == "all") {
        this.$store.dispatch("getAllBrandProfile");
        this.resetBrandData();
      } else {
        this.$store.state.selectedBrandProduct = data.id;
      }
    },
    resetBrandData() {
      this.$store.state.product.actionSelectionControl = false;
      this.$store.state.product.selectedProducts = [];
      this.$store.state.currentPageNumber = 1;
      this.$store.state.selectedBrandProduct = "";
      this.selectedBrandProfle = [];
      this.getFilterProducts();
      this.$store.dispatch("getAllBrandProfile");
    },
    toggleLoader(state){
      this.$emit('toggleLoader',state);
    }
    ,
    exportExcel(){
      debugger
      let vm = this;
      this.toggleLoader(true);
      this.$store.dispatch('asinScapper/getAsinDownloadUrl').then((response)=>{
        this.toggleLoader(false);
        if(response){
          vm.isTimeOut = false;
          vm.downloadLink = response.Location
          window.$("#exportFilePopUp").modal({
            show: true
          })
        }
        else{
          vm.isTimeOut = true
          window.$("#exportFilePopUp").modal({
            show: true
          })
        }
      })

	  },
    closePopUpExport(){
		this.isTimeOut = false;
		this.downloadLink = '';
	},
  },
};
</script>

<style lang="scss">
</style>
